import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.43 14.366c-.464.614-1.256 1.469-2.03 1.056-.431-.228-.611-.868-.573-1.567.022-.447.12-.901.219-1.355-.01.33.037 1.389.827 1.476.305.03.695-.172 1.096-.568l4.777-4.743-4.315 5.7zM21.905 7.7L19.87 4.18l-1.217-2.11c.034-.11.074-.214.103-.325l-1.45-.39a5.514 5.514 0 01-6.744 3.896l-.557-.15L4.211 15.14a4.999 4.999 0 01-1.663 1.727 2.222 2.222 0 00-.96 2.514A2.221 2.221 0 003.743 21h2.042a7.8 7.8 0 003.892-1.043l10.58-6.11a4.473 4.473 0 002.098-2.731 4.476 4.476 0 00-.45-3.415z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.861 28.731c-.93 1.228-2.514 2.938-4.062 2.112-.862-.456-1.222-1.736-1.146-3.134.044-.894.242-1.802.438-2.71-.02.66.074 2.778 1.654 2.952.61.062 1.39-.344 2.192-1.136l9.554-9.486-8.63 11.402zm20.946-13.33l-4.066-7.04-2.434-4.22c.068-.218.148-.428.206-.65l-2.898-.778c-1.57 5.868-7.626 9.36-13.49 7.79l-1.114-.298L8.423 30.281a9.998 9.998 0 01-3.326 3.454 4.443 4.443 0 00-1.918 5.028A4.442 4.442 0 007.483 42h4.084c2.728 0 5.42-.722 7.784-2.086l21.162-12.218a8.947 8.947 0 004.194-5.464 8.953 8.953 0 00-.9-6.83z",
    clipRule: "evenodd"
  }))
};
export var ShoeFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});